import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/firestore';
import 'firebase/storage'

import React, { useState, useEffect } from "react";

import { useFirestoreDocData, useFirestoreDocDataOnce, useFirestore, SuspenseWithPerf, useFirestoreCollectionData } from 'reactfire';

export function useGamerData (ethAddress) {

    const [isLoading, setIsLoading] = useState(null);
    const [isError, setIsError] = useState(null);
    const [currentData, setCurrentData] = useState(null);
    const [currentAddress, setCurrentAddress] = useState(null);
    const [hasGamerName, setHasGamerName] = useState(false);
    const [hasLoaded, setHasLoaded] = useState(false);

    useEffect(() => {

        console.log(`useGamerData: ${ethAddress}`);

        if(ethAddress && currentAddress !== ethAddress){
            setCurrentAddress(ethAddress);
        }

    },[ethAddress])


    const refGamer = useFirestore()
    .collection('gamerData')
    .where("ethAddress", "==", ethAddress);

    const dataGamer = useFirestoreCollectionData(refGamer);

    useEffect(() => {

        console.log('Data Change', dataGamer);

        if(dataGamer.status === "loading"){
            setCurrentData(null);
            setHasLoaded(false);
        } else if(dataGamer.status === "success"){
            if(dataGamer.data){
                setCurrentData(dataGamer.data[0]);
            }

            setHasLoaded(true);
        }



    },[dataGamer, dataGamer.status])

    useEffect(() => {

        if(currentData !== null && currentData !== undefined){
            console.log(`Current Data`, currentData);

            if(currentData.gamerName && currentData.gamerName !== hasGamerName){
                setHasGamerName(currentData.gamerName);
            }
        }


    },[currentData])

    return {
        data: currentData,
        hasGamerName: hasGamerName,
        hasLoaded: hasLoaded,
    }

}
